export const ContactMeUrl = 'https://forms.vw.co.za/i/get-in-touch';
